const mockSessions = [
    {
        id: 1,
        company_name: 'Samsung',
        speaker: 'Kübra Kurşun',
        duration: 15,
        total_quota: 16,
        booked_count: 4, // 12/16 remaining means 4 booked
        date: '20.01.2026',
        day_label: 'Salı 20 Ocak',
        booked_slots: ['10:00 - 10:15', '11:45 - 12:00', '12:00 - 12:15', '14:00 - 14:15'],
        status: 'Aktif',
        academic_year: '2025-2026',
        semester: 'Güz',
        faculty: 'Mühendislik ve Doğa Bilimleri Fakültesi',
        department: 'Bilgisayar Mühendisliği'
    },
    {
        id: 2,
        company_name: 'Google',
        speaker: 'Can Yılmaz',
        duration: 15,
        total_quota: 16,
        booked_count: 2,
        date: '22.01.2026',
        day_label: 'Perşembe 22 Ocak',
        booked_slots: ['11:30 - 11:45', '15:00 - 15:15'],
        status: 'Aktif',
        academic_year: '2025-2026',
        semester: 'Güz',
        faculty: 'Mühendislik ve Doğa Bilimleri Fakültesi',
        department: 'Yazılım Mühendisliği'
    }
];

const mockParticipants = [
    {
        id: 1,
        session_id: 1,
        student_number: '2003923',
        company_name: 'Samsung',
        speaker: 'Kübra Kurşun',
        student_name: 'Selen',
        student_surname: 'Aytaş',
        department: 'Bilgisayar Mühendisliği',
        faculty: 'Mühendislik ve Doğa Bilimleri Fakültesi',
        class_level: '3',
        academic_year: '2025-2026',
        semester: 'Güz',
        quota_label: '1/16',
        appointment_time: '10:00 - 10:15',
        cv_name: 'img455.pdf',
        status: 'Aktif'
    },
    {
        id: 2,
        session_id: 1,
        student_number: '2004561',
        company_name: 'Samsung',
        speaker: 'Kübra Kurşun',
        student_name: 'Ahmet',
        student_surname: 'Yılmaz',
        department: 'Bilgisayar Mühendisliği',
        faculty: 'Mühendislik ve Doğa Bilimleri Fakültesi',
        class_level: '4',
        academic_year: '2025-2026',
        semester: 'Güz',
        quota_label: '2/16',
        appointment_time: '11:45 - 12:00',
        cv_name: 'ahmet_cv.pdf',
        status: 'Aktif'
    }
];

const timeSlots = [
    '10:00 - 10:15', '11:30 - 11:45', '13:30 - 13:45', '15:00 - 15:15',
    '10:15 - 10:30', '11:45 - 12:00', '13:45 - 14:00', '15:15 - 15:30',
    '10:30 - 10:45', '12:00 - 12:15', '14:00 - 14:15', '15:30 - 15:45',
    '10:45 - 11:00', '12:15 - 12:30', '14:15 - 14:30', '15:45 - 16:00'
];

const getAll = async (config) => {
    let rows = [...mockSessions];
    const filter = config?.params?.filter ?? {};

    if (filter.company_name) {
        rows = rows.filter(row => row.company_name.toLowerCase().includes(filter.company_name.toLowerCase()));
    }
    if (filter.start_date) {
        rows = rows.filter(row => row.date === filter.start_date);
    }
    if (filter.status) {
        rows = rows.filter(row => row.status === filter.status);
    }
    if (filter.academic_year) {
        rows = rows.filter(row => row.academic_year === filter.academic_year);
    }
    if (filter.semester) {
        rows = rows.filter(row => row.semester === filter.semester);
    }

    const formattedRows = rows.map(row => ({
        ...row,
        quota: `${row.total_quota - row.booked_count}/${row.total_quota}`
    }));

    return Promise.resolve({
        data: {
            data: formattedRows,
            pagination: {
                total: rows.length
            }
        }
    });
};

const apply = async (id, slot, cvId) => {
    const session = mockSessions.find(s => s.id === Number(id));
    if (session) {
        if (!session.booked_slots.includes(slot)) {
            session.booked_slots.push(slot);
            session.booked_count++;
        }
    }
    return Promise.resolve({ data: { message: 'success' } });
};

const getSlots = async () => {
    return Promise.resolve({ data: timeSlots });
};

const getParticipants = async (config) => {
    let rows = [...mockParticipants];
    const sessionId = config?.sessionId;
    if (sessionId) {
        rows = rows.filter(row => row.session_id === Number(sessionId));
    }

    const filter = config?.params?.filter ?? {};
    if (filter.faculty) {
        rows = rows.filter(row => row.faculty.toLowerCase().includes(filter.faculty.toLowerCase()));
    }
    if (filter.department) {
        rows = rows.filter(row => row.department.toLowerCase().includes(filter.department.toLowerCase()));
    }
    if (filter.class_level) {
        rows = rows.filter(row => row.class_level === filter.class_level);
    }
    if (filter.academic_year) {
        rows = rows.filter(row => row.academic_year === filter.academic_year);
    }
    if (filter.semester) {
        rows = rows.filter(row => row.semester === filter.semester);
    }
    if (filter.status) {
        rows = rows.filter(row => row.status === filter.status);
    }
    if (filter.student_number) {
        rows = rows.filter(row => row.student_number.includes(filter.student_number));
    }
    if (filter.company_name) {
        rows = rows.filter(row => row.company_name.toLowerCase().includes(filter.company_name.toLowerCase()));
    }

    return Promise.resolve({
        data: {
            data: rows,
            pagination: {
                total: rows.length
            }
        }
    });
};

const create = async (formData) => {
    const newSession = {
        id: mockSessions.length ? Math.max(...mockSessions.map(s => s.id)) + 1 : 1,
        company_name: formData.company_name,
        speaker: formData.speaker,
        duration: 15,
        total_quota: 16,
        booked_count: 0,
        date: formData.date || '20.01.2026',
        day_label: formData.date ? `Tarih: ${formData.date}` : 'Salı 20 Ocak',
        booked_slots: [],
        status: 'Aktif',
        academic_year: '2025-2026',
        semester: 'Güz',
        faculty: formData.faculty || 'Mühendislik ve Doğa Bilimleri Fakültesi',
        department: formData.department || 'Bilgisayar Mühendisliği'
    };
    mockSessions.push(newSession);
    return Promise.resolve({ data: { message: 'success', data: newSession } });
};

const remove = async (id) => {
    const index = mockSessions.findIndex(s => s.id === Number(id));
    if (index !== -1) {
        mockSessions.splice(index, 1);
    }
    return Promise.resolve({ data: { message: 'success' } });
};

const updateStatus = async (id, status) => {
    const session = mockSessions.find(s => s.id === Number(id));
    if (session) {
        session.status = status;
    }
    return Promise.resolve({ data: { message: 'success' } });
};

const deleteParticipation = async (id) => {
    const index = mockParticipants.findIndex(p => p.id === Number(id));
    if (index !== -1) {
        const p = mockParticipants[index];
        const session = mockSessions.find(s => s.id === p.session_id);
        if (session) {
            session.booked_slots = session.booked_slots.filter(slot => slot !== p.appointment_time);
            session.booked_count = Math.max(0, session.booked_count - 1);
        }
        mockParticipants.splice(index, 1);
    }
    return Promise.resolve({ data: { message: 'success' } });
};

const reschedule = async (id, newSlot) => {
    const participant = mockParticipants.find(p => p.id === Number(id));
    if (participant) {
        const session = mockSessions.find(s => s.id === participant.session_id);
        if (session) {
            session.booked_slots = session.booked_slots.filter(slot => slot !== participant.appointment_time);
            session.booked_slots.push(newSlot);
        }
        participant.appointment_time = newSlot;
    }
    return Promise.resolve({ data: { message: 'success' } });
};

export default {
    getAll,
    apply,
    getSlots,
    getParticipants,
    create,
    remove,
    updateStatus,
    deleteParticipation,
    reschedule
};
